import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    whichPage: 'HomePage',
    isPoolOpen: true,
    isFixed: false,
    isVisible: true,
    modal: {
        isModalOpen: false,
        sectionOpen: null,
        isAllFilters: false
    },
    isAllFiltersOpen: false

}
const searchbarSlice = createSlice({
    name: 'searchbar',
    initialState: initialState,
    reducers: {
        setIsVisible: (state, action) => { state.isVisible = action.payload }, // true o false
        setIsFixed: (state, action) => { state.isFixed = action.payload }, // true o false
        setIsModalOpen: (state, action) => { state.modal.isModalOpen = action.payload }, // true o false
        setSectionOpen: (state, action) => { state.modal.sectionOpen = action.payload }, // "where", "who", "when", null
        setIsAllFilters: (state, action) => { state.modal.isAllFilters = action.payload }, // true o false
        setIsPoolOpen: (state, action) => { state.isPoolOpen = action.payload },
        setWhichPage: (state, action) => { state.whichPage = action.payload },
        setIsAllFiltersOpen: (state, action) => { state.isAllFiltersOpen = action.payload }
    }
})

export const { setIsVisible, setIsFixed, setIsModalOpen, setSectionOpen, setIsAllFilters, setIsPoolOpen, setWhichPage, setIsAllFiltersOpen } = searchbarSlice.actions;
export default searchbarSlice.reducer;